import { render } from "./SwitchProButton.vue?vue&type=template&id=7ca466ea&scoped=true"
import script from "./SwitchProButton.vue?vue&type=script&lang=js"
export * from "./SwitchProButton.vue?vue&type=script&lang=js"

import "./SwitchProButton.vue?vue&type=style&index=0&id=7ca466ea&scoped=true&lang=css"

import exportComponent from "/vhost/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca466ea"]])

export default __exports__